var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileRecharge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.875,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E39B2B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 8.3335H17.375C16.4467 8.3335 15.5565 8.70225 14.9001 9.35862C14.2437 10.015 13.875 10.9052 13.875 11.8335V28.1668C13.875 29.0951 14.2437 29.9853 14.9001 30.6417C15.5565 31.2981 16.4467 31.6668 17.375 31.6668H24.375C25.3033 31.6668 26.1935 31.2981 26.8499 30.6417C27.5063 29.9853 27.875 29.0951 27.875 28.1668V11.8335C27.875 10.9052 27.5063 10.015 26.8499 9.35862C26.1935 8.70225 25.3033 8.3335 24.375 8.3335ZM20.875 29.3335C20.5866 29.3335 20.3046 29.248 20.0648 29.0877C19.825 28.9275 19.6381 28.6997 19.5277 28.4332C19.4173 28.1668 19.3884 27.8735 19.4447 27.5907C19.501 27.3078 19.6399 27.0479 19.8438 26.844C20.0478 26.64 20.3076 26.5011 20.5905 26.4449C20.8734 26.3886 21.1666 26.4175 21.4331 26.5278C21.6996 26.6382 21.9273 26.8251 22.0876 27.065C22.2478 27.3048 22.3333 27.5867 22.3333 27.8752C22.3333 28.2619 22.1797 28.6329 21.9062 28.9064C21.6327 29.1799 21.2618 29.3335 20.875 29.3335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileRecharge);
export default __webpack_public_path__ + "static/media/mobile_recharge.a6e8cccb2efd97fce0e1aa027d395548.svg";
export { ForwardRef as ReactComponent };